/**************************************************
 * Nombre:       Tarjeta_Paso
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useEffect, useState} from "react";

const Tarjeta_Paso = ({item, index, click}) => {
    const [img, setImg] = useState('');

    useEffect(() => {
        if (typeof item.img === 'object') {
            setImg(URL.createObjectURL(item.img))
        } else if (item.img !== undefined) {
            console.log(item.img)
            setImg(item.img)
        }
    },[item])
    return (
        <Grid
            onClick={() => click(item, index)}
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: '#F7F3FE', p: 1, borderRadius: 2}}
        >

            <Grid container size={3} sx={{justifyContent: 'flex-start'}}>
                <img src={img} width={'90%'} height={'auto'} style={{borderRadius: '8px'}} />
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={9}>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 14, fontWeight: 600}}>{item.nombre}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 12}}>{item.descripcion}</Typography>
                </Grid>

            </Grid>





        </Grid>
    )

}
export default Tarjeta_Paso